import Banner from '../../sections/common/banner';
import Intro from '../../sections/common/intro';
import SectionServices2 from '../../sections/home/index2/section-services2';
import SectionEstimation2 from '../../sections/home/index2/section-estimation2';
import SectionBooking1 from '../../sections/home/index/section-booking1';
import SectionPricing1 from '../../sections/home/index2/section-pricing1';
import { data } from '../../../globals/data/diamond';
import SectionBlogs2 from '../../sections/home/index2/section-blogs2';
import ServicesPageHelmet from '../../helmets/ServicesPageHelmet';

export default function DiamondsPage() {
  return (
    <>
      <ServicesPageHelmet />
      <Banner _data={data.banner} />
      <Intro _data={data.intro} />

      {/* <SectionServices2 _data={data.services} /> */}
      <SectionEstimation2 _data={data.estimation} />
      <SectionBlogs2 _data={data.blogs} />

      {/* <SectionBooking1 _data={data.booking} /> */}
      {/* <SectionPricing1 _data={data.plans} /> */}
    </>
  );
}
